import React from "react";
import { ReactSVG } from "react-svg";

const InfoTool = ({ id, ariaLabel = "Info", className = "" }) => {
  return (
    <button
      aria-label={ariaLabel}
      data-tooltip-id={id}
      type="button"
      className={`inline-flex items-center justify-center p-[3px] w-[30px] h-[30px] ${className}`}
    >
      <ReactSVG
        src="/icons/information-circle-new.svg"
        beforeInjection={(svg) => svg.setAttribute("aria-hidden", "true")}
        className="w-6 h-6 block"
      />
    </button>
  );
};

export default InfoTool;
